import React, { useState, useEffect, useContext } from "react";
import { MyProfileGalleryContainer, ImageGallery } from "./MyProfileGalleryStyled";
import { FormattedMessage } from 'react-intl';

import camera from './../../utils/images/camera.svg';
import deleteIcon from './../../utils/images/close_circle.svg';
import Spinner from "../Spinner/Spinner";
import { handleImageUpload } from "../../services/compress";
import { uploadImageS3 } from "../../utils/common/s3";
import { UserContext2 } from "../../context/user/userContext";
import { UserTypes } from "../../utils/constants/user";
import { GalleryAPI } from "../../api/user/influencer/gallery";

export default function MyProfileGallery() {
    const [imageToSend, setImageToSend] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { userData, setUserData, userType } = useContext(UserContext2);

    const saveImage = () => {
        if (!imageToSend) return;

        setIsLoading(true);
        const imageBody = {
            file: imageToSend,
            address: userType === UserTypes.INFLUENCER 
                ? `fluincr/${userData?.account}/profile`
                : `company/${userData?.account}/profile`
        };

        const fileType = imageToSend.type;

        uploadImageS3(imageBody.address, fileType, imageToSend)
            .then((fileLink) => {
                if (fileLink) {
                    GalleryAPI.addGalleryItem(fileLink)
                        .then((newGalleryItem) => {
                            setIsLoading(false);
                            setImageToSend(null);
                            setUserData((prevUserData) => ({
                                ...prevUserData,
                                profile_data: {
                                    ...prevUserData.profile_data,
                                    gallery: [...prevUserData.profile_data.gallery, newGalleryItem],
                                },
                            }));
                        })
                        .catch((error) => {
                            console.error(error);
                            setIsLoading(false);
                        });
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        if (imageToSend) {
            saveImage();
        }
    }, [imageToSend]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsLoading(true);
        handleImageUpload({ event: e, maxWidthOrHeight: 1024 })
            .then((compressedFile) => {
                setImageToSend(compressedFile);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };

    const showCards = () => {
        const emptySlots = 8 - (userData?.profile_data?.gallery.length || 0);
        return Array.from({ length: emptySlots }, (_, index) => (
            <div className="uploadImage" key={index}>
                <label htmlFor={`gallery-file-input-${index}`} className="fileLabel">
                    <div className="card">
                        <img src={camera} alt="camera" />
                        <p>
                            <FormattedMessage id="my_profile_text_16" defaultMessage="Cargar nueva imagen" />
                        </p>
                    </div>
                </label>
                <input
                    type="file"
                    id={`gallery-file-input-${index}`}
                    accept="image/png, image/jpeg"
                    onChange={handleImageChange}
                />
            </div>
        ));
    };

    const deleteImage = (id) => {
        setIsLoading(true);
        GalleryAPI.deleteGalleryItem(id)
            .then(() => {
                setIsLoading(false);
                setUserData((prevUserData) => ({
                    ...prevUserData,
                    profile_data: {
                        ...prevUserData.profile_data,
                        gallery: prevUserData.profile_data.gallery.filter((galleryItem) => galleryItem.id !== id),
                    },
                }));
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };

    return (
        <MyProfileGalleryContainer>
            <h2 className="title">
                <FormattedMessage id="my_profile_subtitle_3" defaultMessage="Contenido" />
            </h2>
            <div className="cardsContainer">
                {userData?.profile_data?.gallery.map((galleryItem, index) => (
                    <div className="imageContainer" key={index}>
                        <img
                            src={deleteIcon}
                            alt="delete"
                            className="delete"
                            onClick={() => deleteImage(galleryItem?.id)}
                        />
                        <ImageGallery image={galleryItem?.url} />
                    </div>
                ))}
                {showCards()}
            </div>
            {isLoading && <Spinner />}
        </MyProfileGalleryContainer>
    );
}
